// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"FormattedPlaintext_paragraph__MTdGj"};